import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resumeexam',
  templateUrl: './resumeexam.component.html',
  styleUrls: ['./resumeexam.component.scss']
})
export class ResumeexamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
